import { palette } from "lib/miolo";
import { getYear } from "date-fns";
import type { IBrazilianCompanyIssuerTopLevelFragment } from "lib/fragments/__generated__/BrazilianCompanyIssuerTopLevel.generated";
import parseDateYmd from "lib/utils/parseDateYmd";

interface IMandatoryMinimumDividendTabContentProps {
  securities: NonNullable<IBrazilianCompanyIssuerTopLevelFragment["securities"]>;
  mandatoryMinimumDividend: NonNullable<IBrazilianCompanyIssuerTopLevelFragment["mandatoryMinimumDividend"]>;
}

export default function MandatoryMinimumDividendTabContent({
  securities,
  mandatoryMinimumDividend,
}: IMandatoryMinimumDividendTabContentProps) {
  const hasNonOrdinarySecurities = securities.some(({ tickerSymbol }) => !tickerSymbol.endsWith("3"));

  return (
    <div css={{ padding: "12px 0px" }}>
      <dl
        css={{
          margin: 0,
          overflow: "hidden",
          fontFamily: "museo-sans-condensed",
          lineHeight: 1.33,
          borderRadius: 4,
          "& > div": {
            display: "grid",
            gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
            padding: "20px 24px",
            "&:nth-of-type(odd)": {
              backgroundColor: palette.catskillWhite,
            },
            "& > dt, dd": {
              margin: 0,
            },
            "& > dt": {
              color: palette.blueBayoux,
              fontWeight: 500,
              fontSize: 14,
              letterSpacing: 1,
            },
            "& > dd": {
              color: palette.pickledBluewood,
              fontWeight: 500,
              fontSize: 14,
              letterSpacing: 1,
            },
          },
          "& a": {
            color: palette.link,
            textDecoration: "none",
            "&:hover": {
              textDecoration: "underline",
            },
          },
        }}
      >
        <div>
          <dt>Dividendo Mínimo Obrigatório</dt>
          <dd>
            <span>{mandatoryMinimumDividend.minimumDividend}</span>
          </dd>
        </div>

        <div>
          <dt>Frequência</dt>
          <dd>
            <span>{mandatoryMinimumDividend.frequency}</span>
          </dd>
        </div>

        {hasNonOrdinarySecurities && (
          <div>
            <dt>ON vs PN</dt>
            <dd>
              <span>{mandatoryMinimumDividend.commonPreferredDiscrepancy || "Sem informações"}</span>
            </dd>
          </div>
        )}
      </dl>

      <div css={{ marginTop: 16 }}>
        <span
          css={{
            color: palette.lynch,
            fontWeight: 500,
            fontSize: 14,
            fontFamily: "museo-sans-condensed",
            letterSpacing: 1,
          }}
        >
          {"Ano de Referência: "}
          <strong>{getYear(parseDateYmd(mandatoryMinimumDividend.reportDate))}</strong>
        </span>
      </div>
    </div>
  );
}
